(() => {
  'use strict';
  document.querySelectorAll('[data-stockroom-form-id]').forEach(status => {
    if (status.dataset.formStatusReady) return;
    status.dataset.formStatusReady = 'true';
    const id = status.dataset.stockroomFormId;
    const root = document.querySelector('[data-forms-id="forms-root-' + CSS.escape(id) + '"]');
    if (!root) return;
    let shadowObserver;
    let observedShadow;
    let timer;
    let poll;
    const observer = new MutationObserver(check);
    function check() {
      const shadow = root.querySelector('shopify-forms-embed')?.shadowRoot;
      if (shadow?.querySelector('form')) {
        status.hidden = true;
        clearTimeout(timer);
        clearInterval(poll);
        observer.disconnect();
        shadowObserver?.disconnect();
        return true;
      }
      if (shadow && shadow !== observedShadow) {
        shadowObserver?.disconnect();
        observedShadow = shadow;
        clearInterval(poll);
        shadowObserver = new MutationObserver(check);
        shadowObserver.observe(shadow, {childList: true, subtree: true});
      }
      return false;
    }
    status.querySelector('[data-form-reload]').addEventListener('click', () => location.reload());
    observer.observe(root, {childList: true, subtree: true});
    if (!check()) {
      poll = setInterval(check, 1000);
      timer = setTimeout(() => {
      if (check()) return;
      status.querySelector('[data-form-loading]').hidden = true;
      status.querySelector('[data-form-retry]').hidden = false;
    }, 45000);
    }
  });
})();
